const EASTERN_TIME_ZONE = 'America/New_York';

export default function ConvertTime(timestamp: number | string | Date | null | undefined): string {
  if (timestamp === null || timestamp === undefined || timestamp === '') return '';

  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (isNaN(date.getTime())) {
    console.error('Invalid timestamp:', timestamp);
    return 'Invalid Time';
  }

  const time = date.toLocaleTimeString('en-GB', {
    timeZone: EASTERN_TIME_ZONE,
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
  const milliseconds = date.getMilliseconds().toString().padStart(3, '0');

  return `${time}.${milliseconds}`;
}
